import { useMemo } from 'react';

import { Pane, PaneHeader, PaneTitle, PaneBody } from '../components/pane';
import { UnderConstruction } from './UnderConstruction';

const AssignedToYouTable = () => {
  return (
    <UnderConstruction>
      Future home of tasks and review items assigned to you.
    </UnderConstruction>
  );
};

export type AssignedToYouPaneProps = {
  activeGroupIds: number[];
};

export const AssignedToYouPane = ({
  activeGroupIds,
}: AssignedToYouPaneProps) => {
  const websocketOptions = useMemo(() => {
    return {
      topic: activeGroupIds.map((id) => `${id}.orders.created`),
    };
  }, [activeGroupIds]);

  return (
    <Pane refetchQueryKey="" websocketOptions={websocketOptions}>
      <PaneHeader>
        <PaneTitle>Assigned to You</PaneTitle>
      </PaneHeader>
      <PaneBody>
        <AssignedToYouTable />
      </PaneBody>
    </Pane>
  );
};
